/**
 * רשימת מסכתות הבבלי ומספר הדפים — משקף backend/src/constants/gemaraTractates.js
 * מינימום דף = 2.
 */
export const GEMARA_TRACTATES = {
  ברכות: 64,
  שבת: 157,
  עירובין: 105,
  פסחים: 121,
  יומא: 88,
  סוכה: 56,
  ביצה: 40,
  'ראש השנה': 35,
  תענית: 31,
  מגילה: 32,
  'מועד קטן': 29,
  חגיגה: 27,
  יבמות: 122,
  כתובות: 112,
  נדרים: 91,
  נזיר: 66,
  סוטה: 49,
  גיטין: 90,
  קידושין: 82,
  'בבא קמא': 119,
  'בבא מציעא': 119,
  'בבא בתרא': 176,
  סנהדרין: 113,
  מכות: 24,
  שבועות: 49,
  'עבודה זרה': 76,
  הוריות: 14,
  זבחים: 120,
  מנחות: 110,
  חולין: 142,
  בכורות: 61,
  ערכין: 34,
  תמורה: 34,
  כריתות: 28,
  מעילה: 22,
  תמיד: 33,
  נידה: 73,
};

export const TRACTATE_NAMES = Object.keys(GEMARA_TRACTATES);

export function getMaxDaf(tractate) {
  const name = String(tractate || '').trim();
  return name ? (GEMARA_TRACTATES[name] ?? null) : null;
}

/** תצוגה: ברכות · דף כ״ג · עמוד א */
export function formatLessonPageRefDisplay(ref, toHebrewNumeral) {
  const tractate = String(ref?.tractate || '').trim();
  const daf = Number(ref?.daf);
  const amud = String(ref?.amud || '').trim();
  if (!tractate || !daf) return '';
  const dafHeb = typeof toHebrewNumeral === 'function' ? toHebrewNumeral(daf) : String(daf);
  // בלי עמוד = כל הדף (דף יומי בהעלאה מרוכזת)
  if (!amud) return `${tractate} · דף ${dafHeb}`;
  if (amud !== 'a' && amud !== 'b') return '';
  const amudHeb = amud === 'a' ? 'א' : 'ב';
  return `${tractate} · דף ${dafHeb} · עמוד ${amudHeb}`;
}
